var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 455.65 433.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke-width: 4px;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: #fff200;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 431.32,
    y1: 24.33,
    x2: 351.32,
    y2: 205.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 24.33,
    y1: 24.33,
    x2: 104.33,
    y2: 205.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 351.32,
    y1: 205.63,
    x2: 104.33,
    y2: 205.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 321.32,
    y1: 409.61,
    x2: 351.32,
    y2: 205.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 134.33,
    y1: 409.61,
    x2: 104.33,
    y2: 205.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 321.32,
    y1: 409.61,
    x2: 134.33,
    y2: 409.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 417.39,
    y1: 264.99,
    x2: 227.82,
    y2: 305.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 38.26,
    y1: 264.99,
    x2: 227.82,
    y2: 305.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 38.26,
    y1: 264.99,
    x2: 24.33,
    y2: 24.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 417.39,
    y1: 264.99,
    x2: 431.32,
    y2: 24.33
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "125.78 205.63 110.12 211.42 104.33 227.08 98.54 211.42 82.88 205.63 98.54 199.84 104.33 184.18 110.12 199.84 125.78 205.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "59.71 264.99 44.05 270.79 38.26 286.44 32.46 270.79 16.81 264.99 32.46 259.2 38.26 243.55 44.05 259.2 59.71 264.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "438.84 264.99 423.18 270.79 417.39 286.44 411.6 270.79 395.94 264.99 411.6 259.2 417.39 243.55 423.18 259.2 438.84 264.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "372.77 205.63 357.11 211.42 351.32 227.08 345.53 211.42 329.87 205.63 345.53 199.84 351.32 184.18 357.11 199.84 372.77 205.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "45.78 24.33 30.12 30.12 24.33 45.78 18.54 30.12 2.88 24.33 18.54 18.54 24.33 2.88 30.12 18.54 45.78 24.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "452.77 24.33 437.11 30.12 431.32 45.78 425.53 30.12 409.87 24.33 425.53 18.54 431.32 2.88 437.11 18.54 452.77 24.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "155.78 409.61 140.12 415.4 134.33 431.05 128.54 415.4 112.88 409.61 128.54 403.81 134.33 388.16 140.12 403.81 155.78 409.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "342.77 409.61 327.11 415.4 321.32 431.05 315.53 415.4 299.87 409.61 315.53 403.81 321.32 388.16 327.11 403.81 342.77 409.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "227.82 276.73 233.06 292.85 250.01 292.85 236.3 302.81 241.54 318.93 227.82 308.97 214.11 318.93 219.35 302.81 205.64 292.85 222.59 292.85 227.82 276.73"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevil);
export default __webpack_public_path__ + "static/media/Devil.7022b853c6225f2bdf3ab5fce183b6ef.svg";
export { ForwardRef as ReactComponent };